import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css']
})
export class TicketsComponent implements OnInit {
  
  pageName = "My Tickets";

  constructor() { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

}
